// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { SecurityTag } from '@Atoms/Info';
import { SecurityTagType } from '@Types';
import { PAPValueArray, SeverityValueArray, TLPValueArray } from 'thehive-sdk';
import { THDropdown } from '@Molecules/Inputs/THDropdown/THDropdown';
import { THMenu } from '@Molecules/THMenu/THMenu';

import './THSecurityTag.scss';

const SecurityMap: Record<SecurityTagType, { label: string; array: readonly number[] }> = {
    severity: {
        label: 'common.editSeverityTitle',
        array: SeverityValueArray,
    },
    tlp: {
        label: 'common.editTLPTitle',
        array: TLPValueArray,
    },
    pap: {
        label: 'common.editPAPTitle',
        array: PAPValueArray,
    },
};

interface THSecurityTagProps {
    type: SecurityTagType;
    value?: number;
    onChange?: (value: number) => void;
    disabled?: boolean;
    hasFullSeverityLabel?: boolean;
}

export const THSecurityTag = ({
    type,
    value,
    onChange,
    disabled,
    hasFullSeverityLabel = false,
}: THSecurityTagProps): ReactElement => {
    return (
        <THDropdown
            menuClassName="th-security-tag__menu"
            triggerElem={(visible) => (
                <SecurityTag
                    fillType={visible ? 'fill' : 'outline'}
                    hasLabel
                    hasFullSeverityLabel={hasFullSeverityLabel}
                    type={type}
                    value={value}
                />
            )}
            trigger={['click']}
            disabled={disabled}
            placement="bottom"
        >
            {SecurityMap[type].array.map((value, index) => (
                <THMenu.Item
                    className="th-security-tag__menu-item"
                    key={type + value + index}
                    onClick={() => onChange?.(value)}
                >
                    <SecurityTag className="th-security-tag__item" hasLabel type={type} value={value} />
                </THMenu.Item>
            ))}
        </THDropdown>
    );
};
